import {Skeleton, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {BookingErrorState} from 'presentation/pages/private/booking/components';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {useGetExamsPreparationQuery} from './queries/useGetExamsPreparationQuery';
import {PrepareModalContentProps} from './types';

const {loadError} = translations['pt-br'].commons;
const {descriptionPart1, descriptionPart2, emptyState} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentsList.examOrientations;

export function PrepareModalContent({examNumber, examName}: PrepareModalContentProps) {
	const {
		beneficiary: {idadeC},
	} = useAccountInformation();
	const {data, isError, isLoading, refetch} = useGetExamsPreparationQuery({
		cdTipoExame: examNumber,
		nuIdade: String(idadeC),
	});

	if (isError) {
		return (
			<BookingErrorState showHeader={false} errorTitle={loadError} handleRefresh={refetch} />
		);
	}

	if (isLoading) {
		return (
			<Stack gap={2}>
				<Skeleton variant="rectangular" width={300} height={30} />
				<Skeleton variant="rectangular" height={150} />
			</Stack>
		);
	}

	const examOrientationsInfo = data?.dsDescricao;

	return (
		<Fragment>
			<Typography>
				{descriptionPart1}{' '}
				<Typography component="span" fontWeight={700} fontSize="0.875rem">
					{examName}
				</Typography>
				, {descriptionPart2}:
			</Typography>
			<Typography>{examOrientationsInfo || emptyState}</Typography>
		</Fragment>
	);
}
